import {
  FETCH_DS1_PRODUCT_FILTERS,
  RESET_DS1_PRODUCT_FILTERS,
} from "../../constants/action.constants";

const initialState = {
  categories: [],
  subCategories: [],
  statuses: [],
};

const ds1ProductFiltersReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DS1_PRODUCT_FILTERS:
      return {
        categories: action.payload.categories || [],
        subCategories: action.payload.subCategories || [],
        statuses: action.payload.statuses || [],
      };
    case RESET_DS1_PRODUCT_FILTERS:
      return initialState;
    default:
      return state;
  }
};

export default ds1ProductFiltersReducer;
